import cars from '../images/cars.png';
import { Grid, Button, Card, Avatar } from '@mui/material';
import babyYoda from "../images/yoga.jpg";
import StormTrooper from "../images/stormtrooper.jpeg";
import Vader from "../images/vader.jpg";
import StarIcon from '@mui/icons-material/Star';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
const Reviews = () => {

    return (
        <div className="container">
            <div style={{ textAlign: "center " }}>
                <div>
                    <h3>Real Clients Reviews</h3>
                    <h1 style={{ fontSize: '2.7rem' }}>What They're Saying</h1>
                </div>
                <Grid container justifyContent="center" spacing={2}>

                    <Grid item xs={12} sm={4}>
                        <Card elevation={15} sx={{ padding: 5 }}>
                            <StarIcon color="primary" /><StarIcon color="primary" /><StarIcon color="primary" /><StarIcon color="primary" /><StarIcon color="primary" />
                            <h1>Best Car I Ever Rented</h1>
                            <div className="line" style={{ margin: 'auto' }} />
                            <h3>Rental car made it so easy to rent a car, we were in and out in no time. Excellent customer service, would definitely recommend.</h3>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-evenly" }}>
                                <Avatar src={babyYoda} sx={{ width: 100, height: 100 }} /><h3 style={{ paddingLeft: 10 }}>Baby Yoda</h3><FormatQuoteIcon color="primary" sx={{ fontSize: 100 }} /></div>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Card elevation={15} sx={{ padding: 5 }}>
                            <StarIcon color="primary" /><StarIcon color="primary" /><StarIcon color="primary" /><StarIcon color="primary" /><StarIcon color="primary" />
                            <h1>Perfect for Galactic Domination</h1>
                            <div className="line" style={{ margin: 'auto' }} />
                            <h3>When I need a rental car to destroy another planet, I look no where else. Rental Car is fast, convenient and always a pleasure to work with.</h3>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-evenly" }}>
                                <Avatar src={Vader} sx={{ width: 100, height: 100 }} /><h3 style={{ paddingLeft: 10 }}>Darth Vader</h3><FormatQuoteIcon color="primary" sx={{ fontSize: 100 }} /></div>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Card elevation={15} sx={{ padding: 5 }}>
                            <StarIcon color="primary" /><StarIcon color="primary" /><StarIcon color="primary" /><StarIcon color="primary" /><StarIcon color="primary" />
                            <h1>My Favorite Company</h1>
                            <div className="line" style={{ margin: 'auto' }} />
                            <h3>They make things so easy and are always pleasant to deal with. My go to for professional car rentals.</h3>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-evenly" }}>
                                <Avatar src={StormTrooper} sx={{ width: 100, height: 100 }} /><h3 style={{ paddingLeft: 10 }}>Storm Trooper</h3><FormatQuoteIcon color="primary" sx={{ fontSize: 100 }} /></div>
                        </Card>
                    </Grid>

                </Grid>
            </div>
        </div >
    )
}

export default Reviews